import React, { useContext } from 'react';
import DialogContext from './DialogContext';
var withDialog = function (ComponentToWrap) {
    return function (props) {
        var _a = useContext(DialogContext) || {}, openDialog = _a.openDialog, closeDialog = _a.closeDialog;
        return <ComponentToWrap {...props} openDialog={openDialog} closeDialog={closeDialog}/>;
    };
};
export default withDialog;
